import request from './index';

export const getPublicHome = (data) => {
  return request({
    url: "/publics/home",
    method: "post",
    data: data,
  });
};

export const getPublicNav = (data) => {
  return request({
    url: "/publics/nav",
    method: "post",
    data,
  });
};

export const getPublicWebInfo = (data) => {
  return request({
    url: "/publics/web-info",
    method: "post",
    data,
  });
};

export const getPublicAboutUs = (data) => {
  return request({
    url: "/publics/about-us",
    method: "post",
    data,
  });
};

export const getPublicAutomWater = (data) => {
  return request({
    url: "/publics/automotive-water",
    method: "post",
    data,
  });
};

export const getPublicResearch = (data) => {
  return request({
    url: "/publics/research",
    method: "post",
    data,
  });
};

export const getPublicCases= (data) => {
  return request({
    url: "/publics/cases",
    method: "post",
    data,
  });
};

export const getPublicCasesDetail= (data) => {
  return request({
    url: "/publics/cases-details",
    method: "post",
    data,
  });
};

export const getPublicNewsCenter = (data) => {
  return request({
    url: "/publics/news-center",
    method: "post",
    data,
  });
};
export const getPublicNewsCenterDeatails = (data) => {
  return request({
    url: "/publics/news-center-details",
    method: "post",
    data,
  });
};

export const getPublicContactUs = (data) => {
  return request({
    url: "/publics/contact-us",
    method: "post",
    data,
  });
};
export const getPublicSubmitMsg = (data) => {
  return request({
    url: "/publics/msg",
    method: "post",
    data,
  });
};

export const getPublicAboutHonor = (data) => {
  return request({
    url: "/publics/about-honor1",
    method: "post",
    data,
  });
};



// WEBPACK FOOTER //
// ./src/api/api.js